export default __webpack_public_path__ + "static/media/Forward.3f1b496f.pdf";